import CovidCases from './CovidCases';

export default CovidCases;
